import { ApiService } from 'services';

export const OPEN_ABOUT = 'OPEN_ABOUT';
export const CLOSE_ABOUT = 'CLOSE_ABOUT';
export const API_STATUS = 'API_STATUS';

function open() {
  return {
    type: OPEN_ABOUT
  };
}

function close() {
  return {
    type: CLOSE_ABOUT
  };
}

function receive(data) {
  return {
    type: API_STATUS,
    apiStatus: data
  };
}

export function openAboutModal() {
  return dispatch => dispatch(open());
}

export function closeAboutModal() {
  return dispatch => dispatch(close());
}

export function getApiStatus() {
  return (dispatch) => {
    const promise = () => ApiService
      .getApiStatus()
      .then((response) => {
        dispatch(receive(response.data));
      }).catch(() => {
        dispatch(receive({
          status: 'Not Running',
          assemblies: []
        }));
      });
    return promise();
  };
}
